import { client } from "../../../graphql";
import { shared } from "../../graphql/shared";

export async function getServicesByExpertId(expertId) {
  return await client.query({
    query: shared.queries.getServicesByExpertId,
    variables: { expertId }
  });
}
